const mapVariantsToPowerItems = (variants)=>variants.filter((variant)=>variant.isPublished
    ).map((variant)=>({
            value: variant.sku,
            label: variant.power
        })
    ).sort((a, b)=>+a.label - +b.label
    )
;

export { mapVariantsToPowerItems };
//# sourceMappingURL=map-variants-to-power-items.js.map
